import React from "react";
import { roles } from "../../../..";
import ExtraFilter from "./ExtraFilters";

const HeartFilter = (props) => {
  return (
    <ExtraFilter
      svg="/General/Heart.svg"
      title="SAVED"
      accept={[roles.client, roles.provider, roles.super_admin]}
      {...props}
    />
  );
};

export default HeartFilter;
